import React from 'react'
import { Maybe } from 'graphql/jsutils/Maybe'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { FaqSection } from '@/organisms/FaqSection'
import { Page } from '@/page'
import { PageDataContext, PageModel } from '@/services/RenderService'

export interface DiscoverPageViewProps {
  pageDataContext: Maybe<PageDataContext>
  page: Maybe<PageModel>
}

export const DiscoverPageView: React.FC<DiscoverPageViewProps> = ({ pageDataContext, page }) => {
  return (
    <main className="overflow-x-hidden bg-core-gray-950 text-white">
      <div className="grid grid-cols-1 gap-14 py-10">
        {!!page && !!pageDataContext && (
          <Page
            page={page}
            pageDataContext={{
              ...pageDataContext,
              contentItemConfig: { padding: true, showThumbnailTitleDescription: true },
            }}
          />
        )}
        <PaddedContainer fluid>
          <FaqSection />
        </PaddedContainer>
      </div>
    </main>
  )
}
